<template>
  <div>
    <div>
      <div :class="{
        'minisieNav__top': (minisizeMenus && !isAnotherModuleAndMinisize) || $route.meta.isIframe,
        'navbar-brand': true
      }">
        <div class="logo">
          <el-image src="img/mini_logo.png" fit="cover"></el-image>
          <div class="logo__text" v-if="!$route.meta.isIframe">
            <p class="logo__text-office" >D.OFFICE</p>
          
          </div>
        </div>
      </div>
      <!-- && currentUser.account != 'siten_haitn' -->
      <!-- v-if="$router.currentRoute.meta.collection != 'Dashboard'" -->
      <div v-if="showProfile">
        <div class="user-infomation" v-if="aRole('Customer')">
          <div class="user-avatar">
            <img @click="goToProfile()" class="navbar-logo-full" :src="
              currentUserBind.infoAccount.anh_dai_dien ?
                currentUserBind.infoAccount.anh_dai_dien : 'img/company.jpg'
            " width="auto" height="95%" alt="Avatar" title="Thông tin" />
          </div>
          <div v-if="!minisizeMenus && isAnotherModuleAndMinisize" class="user-name_position">
            <p class="uer-name" title="Thông tin" @click="goToProfile()">{{ currentUserBind.infoAccount.name }} <span><i
                  class="fas fa-id-card"></i></span></p>
            <p v-if="!isCompany" class="user-position">{{ currentUserBind.infoAccount.chucVu }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LanguageService from "../service/LanguageService";
import MethodService from "../service/MethodService";
import ExtensionService from "../service/ExtensionService";
import ProfileApi from "../moduleApi/ProfileApi";
import CompanyApi from '../moduleApi/CompanyApi';
import PositionApi from '../moduleApi/PositionApi';
import EventBus from "../service/EventBus";

export default {
  props: {
    minisizeMenus: {
      type: Boolean,
      default: false
    },
    isAnotherModuleAndMinisize: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      showAvatar: false,
      aLang: LanguageService.lang,
      aRole: MethodService.checkRole,
      itemsCount: 0,
      currentUser: MethodService.getCurrentUser(),
      currentUserBind: {
        account: "",
        infoAccount: {
          anh_dai_dien: "",
          name: "",
          chucVu: ""
        }
      },
      mData: {
        hideProfileLink: false,
        listChucVu: []
      },
      isCompany: false,
      showProfile: false
    }
  },
  methods: {
    async initDataDefault() {
      const positionApiRes = await PositionApi.list({ limit: 1000 }, true);
      this.mData.listChucVu = positionApiRes.result;
    },
    async fn_getAccount() {
      const profileApiRes = await ProfileApi.findById(this.currentUser.id, true);
      if (profileApiRes.result) {
        if (profileApiRes.result.name && profileApiRes.result.name.full_name) {
          this.currentUserBind.infoAccount.name = profileApiRes.result.name.full_name;
        }
        const checkCompany = await CompanyApi.findById(this.currentUser.id);
        if (checkCompany.result) {
          this.isCompany = true;
          if (checkCompany.result.logo_id) {
            this.currentUserBind.infoAccount.anh_dai_dien = ExtensionService.urlImg + checkCompany.result.logo_id + "&r=square&w=800";
          }
        } else {
          const employeeRes = this.$store.state.employeeInfo;
          if (employeeRes && employeeRes.image_id) {
            this.currentUserBind.infoAccount.anh_dai_dien = ExtensionService.urlImg + employeeRes.image_id + "&r=square&w=800";
          } else if (employeeRes && employeeRes.administrative_info.avatar_id) {
            this.currentUserBind.infoAccount.anh_dai_dien = ExtensionService.urlImg + employeeRes.administrative_info.avatar_id + "&r=square&w=800";
          }
          let curentTime = new Date().getTime();
          let validJobInfo = employeeRes.job_info.filter((x) => {
            if (x.end_date) {
              return (new Date(x.start_date).getTime() <= curentTime && curentTime <= new Date(x.end_date).getTime());
            } else {
              return new Date(x.start_date).getTime() <= curentTime;
            }
          });
          let chucVu = this.mData.listChucVu.find((element) => {
            return (element.id == (validJobInfo[0] && validJobInfo[0].position_id ? validJobInfo[0].position_id : ""));
          });
          if (chucVu && chucVu.name) {
            this.currentUserBind.infoAccount.chucVu = chucVu.name;
          } else {
            this.currentUserBind.infoAccount.chucVu = " ";
          }
        }
        this.$forceUpdate();
        this.loading = false;
        this.checkShowInfomation();
      }
    },
    goToProfile() {
      if (this.isCompany) {
        let company = MethodService.getCompanyInfo();
        this.$router.push({
          name: "Admin-CompanyInfo-detail",
          params: { id: company.id }
        })
      } else {
        let currentUser = MethodService.getCurrentUser();
        this.$router.push({
          name: "Admin-EmployeeInfo-detail",
          params: { id: currentUser.id }
        })
      }
    },
    checkShowInfomation() {
      if (
        !this.loading &&
        (
          this.$router.currentRoute.meta.collection != 'DashboardCEO' &&
          this.$router.currentRoute.meta.collection != 'DashboardHR' &&
          this.$router.currentRoute.meta.collection != 'DashboardBusiness'
        )
      ) {
        this.showProfile = true;
      } else {
        this.showProfile = false;
      }
    }
  },
  async created() {
    this.loading = true;
    await this.initDataDefault();
    if (this.$router.currentRoute.meta.collection != 'Dashboard') {
      await this.fn_getAccount();
    }
    EventBus.$off("click_HSCN_Name");
    EventBus.$on("click_HSCN_Name", async () => {
      this.loading = true;
      await this.initDataDefault();
      await this.fn_getAccount();
    });
    EventBus.$off("ChangeRouteCheckHideInformation");
    EventBus.$on("ChangeRouteCheckHideInformation", () => {
      setTimeout(() => {
        this.checkShowInfomation();
      }, 300);
    });
  }
}
</script>
<style scoped>
.mr-134 {
  margin-right: 13.4px;
}

.logo {
  z-index: 2;
  display: flex;
  height: 100px;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}

.logo .logo__text .logo__text-office {
  text-transform: uppercase;
  font-family: Rubik !important;
  font-style: normal;
  font-weight: 500;
  font-size: 25px;
  line-height: 26px;
  color: var(--black-title);
}



.navbar-brand {
  margin-top: 10px;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  padding: 8px 20px 5px 20px;
  margin-right: 0;
  height: 65px;
}

.navbar-brand.minisieNav__top {
  padding: 25px 15px 20px 15px;
  margin-top: 0;
}

.navbar-brand .el-image {
  margin-right: 13.4px;
}

.navbar-brand.minisieNav__top .el-image {
  margin-right: 0;
}

.navbar-brand.minisieNav__top .logo__text {
  display: none;
}

.sidebar.minisieNav .user-infomation {
  padding: 8px;
}

.user-infomation {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
  padding-top: 38px;
}

.user-avatar {
  border-radius: 50%;
  max-width: 90px;
  border: 3px solid var(--orange);
  margin-bottom: 15px;
}

.user-avatar img {
  border-radius: 50%;
  max-height: 65px;
}

.user-infomation .user-name_position {
  text-align: center;
}

.user-infomation .user-name_position .uer-name {
  color: var(--orange);
  font-size: 17px;
  line-height: 25px;
  font-family: UTM AvoBold !important;
  font-style: normal;
  font-weight: bold;
  word-break: break-word;
  white-space: break-spaces;
  padding-left: 10px;
  padding-right: 10px;
}

.user-infomation .user-name_position .uer-name:hover,
.navbar-logo-full:hover {
  cursor: pointer;
}

.user-infomation .user-name_position .user-position {
  font-family: UTM Avo;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  color: #444242;
  word-break: break-word;
  white-space: break-spaces;
}

@media (max-width: 767px) {
  .sidebar-mobile-top {
    width: 100%;
    flex: 0 0 auto;
  }

  .navbar-brand,
  .navbar-brand.minisieNav__top {
    width: 100%;
    height: auto;
    margin: 0;
    padding: 24px 16px 0;
    box-sizing: border-box;
  }

  .logo {
    width: 100%;
    height: auto;
    gap: 8px;
    justify-content: flex-start;
  }

  .logo .el-image {
    width: 62px;
    height: auto;
    margin-right: 0;
  }

  .logo .logo__text .logo__text-office {
    font-size: 20px;
    line-height: 12px;
    margin-top: 2px;
    margin-bottom: 0;
  }

  .navbar-brand.minisieNav__top .logo__text {
    display: block;
  }

  .user-infomation,
  .sidebar.minisieNav .user-infomation {
    width: 100%;
    margin: 0;
    padding: 16px 16px 18px;
    box-sizing: border-box;
  }

  .user-avatar {
    width: 86px;
    height: 86px;
    max-width: 86px;
    margin: 0 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .user-avatar img {
    width: 86px;
    height: 86px;
    max-height: none;
    object-fit: cover;
  }

  .user-infomation .user-name_position {
    width: 100%;
    min-width: 0;
  }

  .user-infomation .user-name_position .uer-name {
    margin: 0;
    padding: 0;
    line-height: 1.35;
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
  }

  .user-infomation .user-name_position .user-position {
    margin: 4px 0 0;
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
  }
}
</style>
